<app-modal title="{{ weekExists() ? 'Edit' : 'Add' }} Default Trading Times" #modalComponent>

  <form (ngSubmit)="onSubmit()" #f="ngForm" class="p-3" autocomplete="off">

    <div ngbAccordion>
      @for (dayOfWeek of daysOfWeekValues; track dayOfWeek) {
        <div ngbAccordionItem>
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton>
              <div class="day-of-week-container">
                <span class="day-of-week">{{ dayOfWeek | dayOfWeekParse }}</span>
                @if (weeklyTimes().get(dayOfWeek)) {
                  <span class="day-of-week-working-time">
                  {{ weeklyTimes().get(dayOfWeek).openingTime | timeParse | dateFormat: 'HH:mm' }} -
                    {{ weeklyTimes().get(dayOfWeek).closingTime | timeParse | dateFormat: 'HH:mm' }}
              </span>
                }
              </div>
            </button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <app-working-times-form-timepicker
                        [storeWorkingTime]="weeklyTimes().get(dayOfWeek)">
                </app-working-times-form-timepicker>
              </ng-template>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="input-date">
      <app-input-date
              [isDisabled]="weekExists()"
              [placeholder]="'Date'"
              [name]="'date'"
              [(inputDate)]="startDate"
              [editDate]="editDate"
              [onlyMondays]="true">
      </app-input-date>
    </div>

    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent.activeModal.close()">Close
      </button>
      <button
              class="btn btn-primary btn-form save-button"
              type="submit"
              [disabled]="!f.valid || !startDate() || loading()">Save
      </button>
    </div>
  </form>
</app-modal>